<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('gerenciarSala.tituloCriar') }}</h5>
          <button type="button" class="btn-close" @click="$emit('fechar')"></button>
        </div>
        <div v-if="avisoConcorrencia" class="alert alert-info py-2 px-3 mb-2">
          {{ avisoConcorrencia }}
        </div>
        <div v-if="somenteLeitura" class="alert alert-warning py-2 px-3 mb-2">
          {{ $t('gerenciarSala.avisoSomenteLeitura') }}
        </div>
        <div class="modal-body">
          <div class="body-scroll">
            <label class="form-label small fw-semibold">{{ $t('gerenciarSala.labelNomeSala') }}</label>
            <input v-model="nome" class="form-control mb-2" :placeholder="$t('gerenciarSala.placeholderNomeSala')" :disabled="somenteLeitura" />

            <label class="form-label small fw-semibold">{{ $t('gerenciarSala.labelBusca') }}</label>
            <input
              v-model="busca"
              @input="buscarColaboradores"
              class="form-control mb-2"
              :placeholder="$t('gerenciarSala.placeholderBusca')"
              :disabled="somenteLeitura"
            />

            <div v-if="busca.length >= 3 && resultados.length" class="mt-2">
              <!-- <h6>Resultados da busca</h6> -->
              <div class="d-flex flex-column gap-2">
                <div
                  v-for="colaborador in resultados"
                  :key="colaborador.id"
                  class="card card-sm shadow-sm py-2 px-3 d-flex flex-row align-items-center justify-content-between"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="colaborador?.foto || defaultAvatar"
                      class="rounded-circle me-3"
                      width="32"
                      height="32"
                      alt="Avatar"
                    />
                    <span>{{ colaborador.nome }}</span>
                  </div>
                  <button
                    class="btn btn-sm btn-outline-primary"
                    @click="adicionarColaborador(colaborador)"
                    :disabled="somenteLeitura"
                  >
                    {{ $t('gerenciarSala.btnAdicionar') }}
                  </button>
                </div>
              </div>
            </div>

            <div v-if="selecionados.length" class="mt-3">
              <h6 class="fw-semibold small">Selecionados</h6>
              <div class="d-flex flex-column gap-2">
                <div
                  v-for="colaborador in selecionados"
                  :key="colaborador.id"
                  class="card card-sm shadow-sm py-2 px-3 d-flex flex-row align-items-center justify-content-between"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="colaborador?.foto || defaultAvatar"
                      class="rounded-circle me-3"
                      width="32"
                      height="32"
                      alt="Avatar"
                    />
                    <span>{{ colaborador.nome }}</span>
                  </div>
                  <button
                    class="btn btn-sm btn-outline-danger"
                    @click="removerColaborador(colaborador)"
                    :disabled="somenteLeitura"
                  >
                    {{ $t('gerenciarSala.btnRemover') }}
                  </button>
                </div>
              </div>
            </div>

            <div v-if="selecionados.length === 0" class="text-muted mt-2">
              {{ $t('gerenciarSala.nenhumSelecionado') }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-secondary" @click="$emit('fechar')">{{ $t('gerenciarSala.btnCancelar') }}</button>
          <button class="btn btn-sm btn-primary" :disabled="somenteLeitura || !nome || selecionados.length === 0" @click="modoEdicao ? salvarAlteracoes() : criarSala()">
            {{ modoEdicao ? $t('gerenciarSala.btnSalvarAlteracoes') : $t('gerenciarSala.btnCriarSala') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '@/utils/stores/userStore'
import axios from 'axios'
import defaultAvatar from '@/assets/img/user-icon.png'

export default {
  props: {
    modoEdicao: {
      type: Boolean,
      default: false
    },
    sala: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      nome: '',
      busca: '',
      resultados: [],
      selecionados: [],
      token: '',
      usuarioId: null,
      defaultAvatar,
      avisoConcorrencia: '',   // mensagem opcional
      avisoTimer: null
    }
  },
  watch: {
    sala: {
      immediate: false,
      handler(nova) {
        if (!this.modoEdicao || !nova) return;

        // Atualiza o nome, se mudou no servidor
        if (typeof nova.nome === 'string' && nova.nome !== this.nome) {
          this.nome = nova.nome;
        }

        // Só mostra aviso se eu CONTINUO membro ativo desta sala
        const aindaSouMembro = (nova.assinantes || []).some(a => a?.assinanteURI?.endsWith(`/${this.usuarioId}`));
        if (aindaSouMembro && !nova.saiuUsuarioAtual) {
          this.avisoConcorrencia = this.$t('gerenciarSala.avisoConcorrencia');
          clearTimeout(this.avisoTimer);
          this.avisoTimer = setTimeout(() => (this.avisoConcorrencia = ''), 4000);
        } else {
          // Fui removido: não mostrar aviso de concorrência
          this.avisoConcorrencia = '';
          clearTimeout(this.avisoTimer);
        }

        // Constrói Set com IDs vindos do servidor
        const idsServidor = new Set(
          (nova.assinantes || []).map(a => parseInt(a.assinanteURI.split('/').pop()))
        );

        // 1) Remove dos selecionados quem saiu
        this.selecionados = this.selecionados.filter(s => idsServidor.has(s.id));

        // 2) Adiciona aos selecionados quem entrou (se ainda não estiver)
        (nova.assinantes || []).forEach(a => {
          const id = parseInt(a.assinanteURI.split('/').pop());
          if (!this.selecionados.some(s => s.id === id)) {
            this.selecionados.push({
              id,
              nome: a.nome,
              foto: a.foto
            });
          }
        });
      }
    }
  },
  computed: {
    souMembroAtivo() {
      if (!this.sala?.assinantes) return false
      return this.sala.assinantes.some(a => a.assinanteURI?.endsWith(`/${this.usuarioId}`))
    },
    somenteLeitura() {
      return this.modoEdicao && !this.souMembroAtivo
    }
  },
  mounted() {
    const userStore = useUserStore()
    this.token = userStore.token
    this.usuarioId = userStore.id

    if (this.modoEdicao && this.sala) {
      this.nome = this.sala.nome || ''
      this.selecionados = [...this.sala.assinantes.map(a => ({
        id: parseInt(a.assinanteURI.split('/').pop()),
        nome: a.nome,
        foto: a.foto
      }))]
    }
  },
  methods: {
    async buscarColaboradores() {
      if (this.busca.length < 3) {
        this.resultados = [];
        return;
      }
      try {
        const res = await axios.get(
          `${this.$dominio}/api/colaboradores?string=${encodeURIComponent(this.busca)}&page=0&size=10`,
          {
            headers: { Authorization: `Bearer ${this.token}` }
          }
        );

        const todos = res.data.colaboradores.map(col => ({
          id: col.id,
          nome: col.nome,
          foto: col.links?.find(l => l.rel === 'foto')?.href || this.defaultAvatar
        }));

        this.resultados = todos.filter(c =>
          !this.selecionados.some(s => s.id === c.id) && c.id !== this.usuarioId
        );
      } catch (err) {
        console.error('Erro ao buscar colaboradores:', err);
        this.resultados = [];
      }
    },
    adicionarColaborador(colab) {
      if (!this.selecionados.some(c => c.id === colab.id)) {
        this.selecionados.push({
          id: colab.id,
          nome: colab.nome,
          foto: colab.foto || this.defaultAvatar
        });
      }

      // Limpa busca e resultados após adicionar
      this.busca = ''
      this.resultados = []
    },
    removerColaborador(colab) {
      this.selecionados = this.selecionados.filter(c => c.id !== colab.id)
    },
    async criarSala() {
      try {
        const assinantes = this.selecionados.map(c => ({ id: c.id }));

        if (!assinantes.some(a => a.id === this.usuarioId)) {
          assinantes.push({ id: this.usuarioId });
        }

        // 1. Cria a sala
        const res = await axios.post(`${this.$dominio}/api/chats`, {
          nome: this.nome,
          assinantes
        }, {
          headers: { Authorization: `Bearer ${this.token}` }
        });

        // 2. Recupera a URI da nova sala criada
        const resourceURI = res.data.resourceURI;

        // 3. Faz um GET completo para obter os dados da sala
        const respostaSala = await axios.get(resourceURI, {
          headers: { Authorization: `Bearer ${this.token}` }
        });

        const novaSala = respostaSala.data;

        // 4. Emite os dados completos para o ChatApp
        this.$emit('salaCriada', novaSala);
        this.$emit('fechar');

      } catch (error) {
        console.error('Erro ao criar sala:', error);
      }
    },
    async salvarAlteracoes() {
      try {
        const idSala = this.sala?.id;
        if (!idSala) return;

        const headers = { headers: { Authorization: `Bearer ${this.token}` } };

        // 1) Atualiza o nome (se mudou)
        const nomeAtual = this.sala?.nome ?? '';
        const nomeNovo = this.nome ?? '';
        if (nomeNovo !== nomeAtual) {
          await axios.put(`${this.$dominio}/api/chats/${idSala}`, { nome: nomeNovo }, headers);
        }

        // 2) Calcula diffs de membros, com parse seguro
        const assinantesOriginais = (this.sala?.assinantes || [])
          .map(a => {
            const uri = a?.assinanteURI || '';
            const idStr = uri.split('/').pop();
            const idNum = parseInt(idStr, 10);
            return Number.isFinite(idNum) ? idNum : null;
          })
          .filter(id => id !== null);

        const idsSelecionados = (this.selecionados || []).map(s => s.id);

        const aAdicionar = idsSelecionados.filter(id => !assinantesOriginais.includes(id));
        const aRemover   = assinantesOriginais.filter(id => !idsSelecionados.includes(id));
        const removiMe   = aRemover.includes(this.usuarioId);

        // 3) Aplica diffs (manter ordem: adiciona antes de remover)
        if (aAdicionar.length > 0) {
          await axios.post(
            `${this.$dominio}/api/chats/${idSala}/assinantes`,
            { assinantes: aAdicionar.map(id => ({ id })) },
            headers
          );
        }

        if (aRemover.length > 0) {
          await axios.delete(
            `${this.$dominio}/api/chats/${idSala}/assinantes`,
            {
              ...headers,
              data: { assinantes: aRemover.map(id => ({ id })) }
            }
          );
        }

        // 4) Se eu saí, tentar pegar sala completa (pode dar 403/404)
        if (removiMe) {
          try {
            const { data: salaAtualizada } = await axios.get(
              `${this.$dominio}/api/chats/${idSala}`,
              { headers: { Authorization: `Bearer ${this.token}` } }
            );
            // Só emite se tiver uma sala válida
            if (salaAtualizada && typeof salaAtualizada.id === 'number') {
              this.$emit('salaAtualizada', salaAtualizada);
            } else {
              this.$emit('salaAtualizada', { id: idSala, saiuUsuarioAtual: true });
            }
          } catch (e) {
            // NUNCA emita e.response.data aqui
            this.$emit('salaAtualizada', { id: idSala, saiuUsuarioAtual: true });
          }
          this.$emit('fechar');
          return;
        }

        // 5) Caso normal: carrega a sala atualizada e emite
        const { data: salaAtualizada } = await axios.get(
          `${this.$dominio}/api/chats/${idSala}`,
          headers
        );
        this.$emit('salaAtualizada', salaAtualizada);
        this.$emit('fechar');

      } catch (err) {
        console.error('Erro ao salvar alterações da sala:', err?.response?.status, err?.response?.data || err);
      }
    }
  }
}
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.5);
}

/* Modal ocupa a tela sem estourar */
.modal-content {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 2rem); /* margem de segurança */
}

/* Header e footer fixos (não crescem) */
.modal-header,
.modal-footer {
  flex: 0 0 auto;
}

/* Body ocupa o restante sem gerar 2 barras de rolagem */
.modal-body {
  flex: 1 1 auto;
  overflow: hidden;            /* importante: quem rola é o .body-scroll */
  display: flex;
  flex-direction: column;
  min-height: 0;               /* ESSENCIAL: permite que o filho flex role */
}

/* Área realmente rolável */
.body-scroll {
  flex: 1 1 auto;
  min-height: 0;               /* ESSENCIAL para o scroll funcionar em flex */
  overflow-y: auto;
  padding-right: 4px;          /* evita salto com a barra */
}

/* Modais do chat acima do chat-container */
.modal {
  z-index: 10000 !important;
}

.modal-backdrop {
  z-index: 9999 !important; /* logo abaixo do modal, mas ainda acima do overlay */
}

/* (Opcional) ajuste para telas pequenas */
@media (max-width: 576px) {
  .modal-content {
    max-height: calc(100vh - 1rem);
  }
}
</style>